export const AGENTS_API_PATHS = {
    KNOWLEDGE: {
        RAG: '/knowledge/assistant', // conocimiento documentado
        RAG_V2: '/knowledge/v2/assistant',
        UPLOAD: '/knowledge/ephemeral/upload',
        DOCUMENTS: '/knowledge/documents',
    },
    CONVERSATIONS: {
        ALL: (page: number, pageSize: number) => `/conversations/search?page=${page}&pageSize=${pageSize}`,
        BY: (id: string) => `/conversations/${id}`,
        ARCHIVE: (id: string) => `/conversations/${id}/archive`,
        RATE: (conversation_id: string, interaction_id: string) =>
            `/conversations/${conversation_id}/interactions/${interaction_id}/rate`,
    },
    DRIVE: {
        INGEST: '/drive/ingest',
        STATUS_BY: (id: string) => `/drive/status/${id}`,
    },
    LOGISTICS: (mindyVersion: string) => `/${mindyVersion}/logistics/assistant`,
    AGENTS: {
        ALL: '/agents',
        SEARCH: '/agents/search',
        BY: (agent_id: string, organization_id?: string) =>
            organization_id ? `/agents/${organization_id}/${agent_id}` : `/agents/${agent_id}`,
    },
    USAGE: {
        BY_USER: (id: string) => `/usage/user/id/${id}`,
        BY_ORGANIZATION: (id: string) => `/usage/organization/id/${id}`,
    },
    DOCUMENTS: {
        ROOT: '/documents',
        UPLOAD: '/documents/upload',
        SEARCH_BY_FOLDER: '/documents/search',
        BY_FILE: (organization_id: string, file_id: string) => `/documents/${organization_id}/id/${file_id}`,
        BY_FOLDER: (organization_id: string, file_id: string) => `/documents/id/${file_id}`,
        IMPORT: 'documents/drive/import',
        IMPORT_BY_URI: '/documents/url/import',
        STATS: '/documents/stats',
        SIGNED_URL: (document_id: string) => `/documents/${document_id}/signed-url`,
        YPF_IMPORT: '/documents/ypf/import-table',
        YPF_TEMPLATE: '/documents/ypf/download-template',
        USERS: (userId: string) => `permissions/users/${userId}/document-permissions`,
        REPLACE: (documentId: string) => `/documents/${documentId}`,
        BY_ID: (document_id: string) => `/documents/${document_id}`,
    },
    FOLDERS: {
        ROOT: '/folders',
    },
    AUTH: {
        GOOGLE: '/auth/google',
        CALLBACK: '/auth/google/callback',
    },
    PERMISSIONS: {
        ROOT: '/permissions',
        ADD_BULK_PERMISSIONS: (document_id: string) => `permissions/documents/${document_id}`,
        DOCUMENT_PERMISSIONS: (document_id: string) => `permissions/documents/${document_id}`,
    },
    QUESTIONS: {
        ALL: '/suggested-questions',
    },
    FEEDBACK: {
        GENERAL_FEEDBACK: '/feedbacks',
    },
    ORGANIZATIONS: {
        USERS_BULK: (organizationId: string) => `organizations/${organizationId}/users/bulk`,
    },
};
